export default {
      id: "print-green-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite.svg#print-green",
      toString: function () {
        return this.url;
      }
    }